import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { OverlapItems } from '@sorare/core/src/atoms/ui/OverlapItems';
import { Avatar } from '@sorare/core/src/components/user/Avatar';

import { MembersRecap_userGroupInterface } from './__generated__/index.graphql';

const Plus = styled.div`
  align-items: center;
  justify-content: center;
  outline: 2px solid var(--bgColor);
  background: var(--c-rivals-friendlies);
  font: var(--t-label-s);
  border-radius: var(--double-unit);
  padding: var(--half-unit);
  color: var(--c-black);
  font-weight: var(--t-bold);
`;

type Props = { squad: MembersRecap_userGroupInterface; onlyFollowed?: boolean };
export const MembersRecap = ({ squad, onlyFollowed }: Props) => {
  const filteredMemberships = onlyFollowed
    ? squad.memberships.filter(m => m.user.followed)
    : squad.memberships;
  const filteredMembershipsCount = filteredMemberships.length;

  return (
    <div>
      <OverlapItems>
        {filteredMemberships.slice(0, 5).map(membership => (
          <Avatar key={membership.id} user={membership.user} rounded size={3} />
        ))}
        {filteredMembershipsCount > 5 && (
          <Plus>+{filteredMembershipsCount - 5}</Plus>
        )}
      </OverlapItems>
    </div>
  );
};

MembersRecap.fragments = {
  userGroupInterface: gql`
    fragment MembersRecap_userGroupInterface on UserGroupInterface {
      slug
      memberships {
        id
        user {
          slug
          followed {
            slug
          }
          ...Avatar_user
        }
      }
    }
    ${Avatar.fragments.user}
  ` as TypedDocumentNode<MembersRecap_userGroupInterface>,
};
